import Vue from 'vue';
import Vuex from 'vuex';

import navMenu from './modules/navMenu';
/* eslint-disable */
import navTag from './modules/navTag';
import login from './modules/login';
import permission from './modules/permission';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navMenu,
    navTag,
    login,
    permission
  },
});
